import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

import Screen from '../Screen/Screen'

const breakpoints = [440, 768, 1024, 1200, 1400];
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`));

const activeWrap = ({ isActive }) => (
  css({
    gridTemplateRows: isActive ? "1fr" : "0fr",
  })
)

export const Wrap = styled.div`
  will-change: grid-template-rows;
  display: grid;
  grid-template-columns: 1fr;
  box-shadow: 0px 1px 0px 0px #538CFF inset;
  transition: grid-template-rows .4s ease-in-out;
  ${activeWrap}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 56px;
  overflow: hidden;
`

const activeButton = ({ isActive }) => {
  if (isActive) {
    return css({
      color: "var(--color-white)",
    })
  }
}

const hoveredButtonMQ = css(mq({
  display: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "none", // 1024+
    "flex", // 1200+
    "flex", // 1400+
  ],
}))

export const HoveredButton = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 56px;
  padding: 14px 0;
  font: var(--accent-570);
  color: var(--color-dark-blue-200);

  & > svg {
    width: 16px;
    height: 16px;
  }

  ${activeButton}
  ${hoveredButtonMQ}
`

const clickableButtonMQ = css(mq({
  display: [
    "flex", // 0+
    "flex", // 440+
    "flex", // 768+
    "flex", // 1024+
    "none", // 1200+
    "none", // 1400+
  ],
}))

export const ClickableButton = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 56px;
  padding: 14px 0;
  font: var(--accent-570);
  color: var(--color-dark-blue-200);

  & > svg {
    width: 16px;
    height: 16px;
  }

  ${activeButton}
  ${clickableButtonMQ}
`

const innerContentMQ = css(mq({
  display: [
    "flex", // 0+
    "flex", // 440+
    "flex", // 768+
    "flex", // 1024+
    "none", // 1200+
    "none", // 1400+
  ],
  margin: [
    "24px 0", // 0+
    "24px 0", // 440+
    "52px 0", // 768+
    "52px 0", // 1024+
  ],
}))

export const InnerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 24px;
  ${innerContentMQ}
`

export const InnerScreen = styled(Screen)`
  margin: 0 10px;
  max-width: calc(100% - 20px);
`
